import React from 'react';
import { MyPersonalChallenges } from './MyPersonalChallenges';
import { CommunityChallenges } from './CommunityChallenges';

interface ChallengesOverviewProps {
  showPersonal?: boolean;
  showCommunity?: boolean;
}

export function ChallengesOverview({ 
  showPersonal = true, 
  showCommunity = true 
}: ChallengesOverviewProps) {
  return (
    <div className="space-y-6">
      {showPersonal && <MyPersonalChallenges />}
      {showCommunity && <CommunityChallenges />}
    </div>
  );
}
